import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import './assets/main.css';

//FONT AWESOME
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)

createApp(App)
  .use(router)
  .component('FontAwesomeIcon', FontAwesomeIcon)  
  .mount('#app')
